import util from '../util'

let controller = 'ExpBACENContaAmostragem'

export default Object.assign({}, util.GetCrud(controller, ['getall', 'post', 'delete']))
